function Transnistria({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_2333)">
  <path d="M31.4488 11.8261C29.6128 5.01381 23.3924 0 16 0C8.60752 0 2.38715 5.01381 0.551147 11.8261L16 12.5218L31.4488 11.8261Z" fill="#A2001D"/>
  <path d="M0.551147 20.1742C2.38715 26.9864 8.60752 32.0003 16 32.0003C23.3924 32.0003 29.6128 26.9865 31.4488 20.1742L16 19.4785L0.551147 20.1742Z" fill="#A2001D"/>
  <path d="M31.4488 11.8262H0.551188C0.1925 13.157 0 14.5559 0 16.0001C0 17.4443 0.1925 18.8432 0.551188 20.174H31.4489C31.8075 18.8432 32 17.4443 32 16.0001C32 14.5559 31.8075 13.157 31.4488 11.8262Z" fill="#6DA544"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Transnistria;
